import convertToOption from '../utils/convert-to-option';

export const merchantFilterFields = ['name'];
export const merchantSelectLabel = object => {
  if (object.countries) {
    if (object.countries.length > 0)
      return `${object.name} - ${object.countries.join(', ')}`;
    return `${object.name} (no active markets)`;
  }
  return `${object.name}`;
};

export const merchantFrameworkOptions = [
  'Loyalty',
  'Annual Agreement',
  'None',
].map(convertToOption);

export const merchantTypesOptions = [
  'Brand',
  'Retailer',
  'Distributor',
  'Service Provider',
  'Connected Retail',
].map(convertToOption);
